export const REDUCER_NAME = 'task-widget'

export const PHOTO_REJECTION_REASONS = [
    {
        name: "teeth_are_overexposed",
        title: "Teeth are overexposed",
    },
    {
        name: "photo_is_too_blurry",
        title: "Photo is too blurry",
    },
    {
        name: "angle_of_the_photo_is_too_small",
        title: "Angle of the photo is too small",
    },
    {
        name: "upper_lip_blocks_the_gums",
        title: "Upper lip blocks the gums",
    },
    {
        name: "lower_lip_blocks_the_gums",
        title: "Lower lip blocks the gums",
    },
    {
        name: "teeth_are_not_properly_clenched_occlusion",
        title: "Teeth are not properly clenched (occlusion)",
    },
    {
        name: "molars_cannot_be_seen",
        title: "Molars cannot be seen",
    },
];



// WEBPACK FOOTER //
// ./src/modules/customer/state/task-widget/const.js